import { ReportAttributes, ReportRelationships } from 'dashboard/models/report';
import { CountryCode } from 'lib/constants/locales';
import { ApiModel, ApiResource } from 'lib/interfaces/api';

export enum SentilinkEnvironmentType {
  Production = 'PROD',
  Sandbox = 'SANDBOX',
}

interface ReasonCode {
  code?: string;
  rank?: number;
  direction?: string;
  explanation?: string;
}

export interface ReportSentilinkApplicationRiskAttributes extends ReportAttributes {
  query: {
    'user-id'?: string;
    'name-first'?: string;
    'name-last'?: string;
    birthdate?: string;
    'address-country-code'?: CountryCode;
    'address-street-1'?: string;
    'address-street-2'?: string;
    'address-city'?: string;
    'address-subdivision'?: string;
    'address-postal-code'?: string;
    'social-security-number'?: string;
    'phone-number'?: string;
    'email-address'?: string;
    'ip-address'?: string;
  };
  result?: {
    'transaction-id'?: string;
    'application-id'?: string;
    'customer-id'?: string;
    environment?: SentilinkEnvironmentType;
    'sentilink-synthetic-score'?: {
      version?: string;
      score?: number;
      'reason-codes'?: ReasonCode[];
    };
    'sentilink-id-theft-score'?: {
      version?: string;
      score?: number;
      'reason-codes'?: ReasonCode[];
    };
    status?: string;
  };
}

export type ReportSentilinkApplicationRisk = ApiResource<
  ReportSentilinkApplicationRiskAttributes,
  ReportRelationships,
  ApiModel.ReportSentilinkApplicationRisk
>;
